// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1arOm","controls":"styles_controls__3VNrX","charLimit":"styles_charLimit__2TN8b","input":"styles_input__3sspV","send":"styles_send__3PdCt"};